const normalizeSkipForEmails = (csv: string): string[] => {
  const parts = csv
    .split(',')
    .map((email) => email.trim())
    .filter(Boolean);
  return Array.from(new Set(parts));
};

const isValidEmail = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export { normalizeSkipForEmails, isValidEmail };
